import { Seo } from "@/components/layout/Seo";
import { PageHero } from "@/components/sections/PageHero";
import { SectionIntro } from "@/components/sections/SectionIntro";
import { OfferingGrid } from "@/components/sections/OfferingGrid";
import { CtaBand } from "@/components/sections/CtaBand";
import { Reveal } from "@/components/motion/Reveal";
import { PARTNER_TYPES, PARTNERSHIP_AREAS } from "@/content/offerings";
import { enquire } from "@/content/navigation";

const PartnerTypes = () => (
  <section className="bg-ivory py-24 text-ink sm:py-32" data-testid="partner-types">
    <div className="shell grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <SectionIntro tone="light" eyebrow="Who We Partner With" title={<>We welcome <em className="text-plum-2">collaboration</em> with</>} />
      </div>
      <ul className="lg:col-span-8">
        {PARTNER_TYPES.map((t, i) => (
          <Reveal as="li" key={t} delay={(i % 4) * 0.04} className="group flex items-baseline justify-between gap-6 border-t border-ink/15 py-5 last:border-b" data-testid={`partner-type-${i + 1}`}>
            <span className="font-display text-2xl font-light tracking-tight transition-[color,transform] duration-500 group-hover:translate-x-2 group-hover:text-plum-2 sm:text-4xl">{t}</span>
            <span className="font-mono text-[11px] text-ink/50">{String(i + 1).padStart(2, "0")}</span>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);

export default function Partnerships() {
  const partner = enquire("Partnership");
  return (
    <>
      <Seo title="Partnerships | Partner With VION Tech" description="Partner with VION Tech on technology, training, corporate training, education, youth digital skills, innovation, AI adoption, sponsorship and strategic collaboration." path="/partnerships" />
      <PageHero
        testid="partnerships-hero"
        eyebrow="Partnerships"
        lines={["Let's Build", "What's Next."]}
        accentLine={1}
        intro="We are open to strategic partnerships with businesses, educational institutions, technology companies, government and development organisations, investors, sponsors and international partners."
        image="/images/partners-hero.webp"
        alt="Two professionals shaking hands across a table to agree a partnership"
        actions={[
          { label: "Partner With VION Tech", to: partner, testid: "partnerships-hero-cta" },
          { label: "Sponsorship Enquiry", to: enquire("Sponsorship"), variant: "outline", testid: "partnerships-sponsor-btn" },
        ]}
      />
      <PartnerTypes />
      <section className="bg-ink py-24 sm:py-32" data-testid="partnership-areas">
        <div className="shell">
          <SectionIntro eyebrow="Partnership Areas" title={<>Where we can <span className="italic text-gold-metal">build together.</span></>} />
          <div className="mt-16">
            <OfferingGrid
              items={PARTNERSHIP_AREAS}
              prefix="partnership"
              ctaLabel="Discuss This"
              ctaHref={(a) => enquire(a.title === "Sponsorship" ? "Sponsorship" : a.title === "Corporate Training" ? "Corporate Training" : "Partnership", a.title)}
            />
          </div>
        </div>
      </section>
      <CtaBand testid="partnerships-cta" eyebrow="Collaborate" title="Partner With VION Tech." text="Tell us about your organisation and the kind of collaboration you have in mind." primary={{ label: "Partner With VION Tech", to: partner }} secondary={{ label: "Contact Us", to: "/contact" }} />
    </>
  );
}
